import { Box, Text } from 'grommet';

// A team name with its season record trailing it, e.g. "Hotel Motel  2-2".
const TeamName = ({ name, record, size }) => (
  <Box direction="row" align="baseline" gap="xsmall" wrap>
    <Text size={size}>{name}</Text>
    {record && <Text size="small" color="text-weak">{record}</Text>}
  </Box>
);

export default TeamName;
